The response from the `deleteCandidateProcessHistoryItem` mutation.
